const u = up.util;
up.migrate.renamedPackage('flow', 'fragment');
up.migrate.renamedPackage('dom', 'fragment');
up.fragment.config.patch(function (config) {
    up.migrate.renamedProperty(config, 'fallbacks', 'mainTargets');
});
up.migrate.handleResponseDocOptions = (docOptions) => up.migrate.fixKey(docOptions, 'html', 'document');
up.fragment.config.patch(function (config) {
    let matchAroundOriginDeprecated = () => up.migrate.deprecated('up.fragment.config.matchAroundOrigin', 'up.fragment.config.match');
    Object.defineProperty(config, 'matchAroundOrigin', {
        configurable: true,
        get: function () {
            matchAroundOriginDeprecated();
            return this.match === 'closest';
        },
        set: function (value) {
            matchAroundOriginDeprecated();
            this.match = value ? 'region' : 'first';
        }
    });
});
up.replace = function (target, url, options) {
    up.migrate.deprecated('up.replace(target, url)', 'up.navigate(target, { url })');
    return up.navigate(Object.assign(Object.assign({}, options), { target, url }));
};
up.extract = function (target, document, options) {
    up.migrate.deprecated('up.extract(target, document)', 'up.navigate(target, { document })');
    return up.navigate(Object.assign(Object.assign({}, options), { target, document }));
};
up.fragment.first = function (...args) {
    up.migrate.deprecated('up.fragment.first()', 'up.fragment.get()');
    return up.fragment.get(...args);
};
up.first = up.fragment.first;
up.migrate.preprocessRenderOptions = function (options) {
    if (u.isString(options.history) && (options.history !== 'auto')) {
        up.migrate.warn("Passing a URL as { history } option is deprecated. Pass it as { location } instead.");
        options.location = options.history;
        options.history = 'auto';
    }
    for (let prop of ['target', 'origin']) {
        if (u.isJQuery(options[prop])) {
            up.migrate.warn('Passing a jQuery collection as { %s } is deprecated. Pass it as a native element instead.', prop);
            options[prop] = up.element.get(options[prop]);
        }
    }
    if (options.fail === 'auto') {
        up.migrate.warn("The option { fail: 'auto' } is deprecated. Omit the option instead.");
        delete options.fail;
    }
    let solo = u.pluckKey(options, 'solo');
    if (u.isString(solo)) {
        up.migrate.warn("The up.render() option { solo } has been replaced with { abort } and { abort } no longer accepts a URL pattern. Check if you can use { abort: 'target'} or use up.network.abort(pattern) instead.");
        options.abort = (options) => up.network.abort(solo, options);
    }
    else if (u.isFunction(solo)) {
        up.migrate.warn("The up.render() option { solo } has been replaced with { abort } and { abort } no longer accepts a Function(up.Request): boolean. Check if you can use { abort: 'target'} or use up.network.abort(fn) instead.");
        options.abort = (options) => { up.network.abort(solo, options); };
    }
    else if (solo === true) {
        up.migrate.deprecated('Option { solo: true }', "{ abort: 'all' }");
        options.abort = 'all';
    }
    else if (solo === false) {
        up.migrate.deprecated('Option { solo: false }', "{ abort: false }");
        up.migrate.warn('Unpoly 3+ only aborts requests targeting the same fragment. Setting { solo: false } may no longer be necessary.');
        options.abort = false;
    }
    up.migrate.fixKey(options, 'failOnFinished', 'onFailFinished');
    up.migrate.fixKey(options, 'badResponseTime', 'lateDelay');
    if (u.isString(options.reveal)) {
        up.migrate.deprecated(`Option { reveal: '${options.reveal}' }`, `{ scroll: '${options.reveal}' }`);
        options.scroll = options.reveal;
    }
    else if (options.reveal === true) {
        up.migrate.deprecated('Option { reveal: true }', "{ scroll: 'target' }");
        options.scroll = 'target';
    }
    else if (options.reveal === false) {
        up.migrate.deprecated('Option { reveal: false }', "{ scroll: false }");
        options.scroll = false;
    }
    if (options.resetScroll === true) {
        up.migrate.deprecated('Option { resetScroll: true }', "{ scroll: 'top' }");
        options.scroll = 'reset';
    }
    if (options.resetScroll === false) {
        up.migrate.deprecated('Option { resetScroll: false }', "{ scroll: false }");
        options.scroll = false;
    }
    if (options.restoreScroll === true) {
        up.migrate.deprecated('Option { restoreScroll: true }', "{ scroll: 'restore' }");
        options.scroll = 'restore';
    }
    if (options.restoreScroll === false) {
        up.migrate.deprecated('Option { restoreScroll: false }', "{ scroll: false }");
        options.scroll = false;
    }
    if (options.scroll === 'reset') {
        up.migrate.deprecated("Option { scroll: 'reset'' }", "{ scroll: 'top' }");
        options.scroll = 'top';
    }
};
up.migrate.postprocessReloadOptions = function (options) {
    var _a;
    let lastModified = (_a = options.headers) === null || _a === void 0 ? void 0 : _a['If-Modified-Since'];
    let legacyHeader;
    if (lastModified) {
        legacyHeader = Math.floor(new Date(lastModified) * 0.001).toString();
    }
    else {
        legacyHeader = '0';
    }
    options.headers[up.protocol.headerize('reloadFromTime')] = legacyHeader;
};
up.migrate.resolveOrigin = function (target, { origin } = {}) {
    let pattern = /"[^"]*"|'[^']*'|&|:origin\b/g;
    return target.replace(pattern, function (variant) {
        if (variant === ':origin' || variant === '&') {
            if (variant === '&') {
                up.migrate.deprecated("Origin shorthand '&'", ':origin');
            }
            if (origin) {
                return up.fragment.toTarget(origin);
            }
            else {
                up.fail('Missing { origin } element to resolve "%s" reference (found in %s)', variant, target);
            }
        }
        else {
            return variant;
        }
    });
};
up.fragment.config.patch(function () {
    Object.defineProperty(this, 'runScripts', {
        configurable: true,
        get() {
            up.migrate.deprecated('up.fragment.config.runScripts', 'up.script.config.scriptElementPolicy = "auto"');
            switch (up.script.config.scriptElementPolicy) {
                case 'auto': return true;
                case 'pass': return true;
                case 'block': return false;
                case 'nonce': return (script) => !!script.nonce;
            }
        },
        set(value) {
            if (value === true) {
                up.migrate.deprecated('up.fragment.config.runScripts = true', 'up.script.config.scriptElementPolicy = "auto"');
                up.script.config.scriptElementPolicy = 'auto';
            }
            else if (value === false) {
                up.migrate.deprecated('up.fragment.config.runScripts = false', 'up.script.config.scriptElementPolicy = "block"');
                up.script.config.scriptElementPolicy = 'block';
            }
            else if (u.isFunction(value)) {
                up.migrate.warn('up.fragment.config.runScripts has been replaced by up.script.config.scriptElementPolicy, but no longer supports a function value.');
                up.script.config.scriptElementPolicy = 'block';
            }
        }
    });
});
up.compiler('[up-keep]', function (element) {
    let selector = up.element.booleanOrStringAttr(element, 'up-keep');
    if (u.isString(selector) && /[.[#]/.test(selector)) {
        up.migrate.warn('The [up-keep] attribute no longer supports a selector value. Elements will be matched by their derived target. You may prevent keeping with [up-on-keep="if(condition) event.preventDefault()"]. ');
        element.addEventListener('up:fragment:keep', function (event) {
            if (event.target === element && !event.newFragment.matches(selector)) {
                event.preventDefault();
            }
        });
        element.setAttribute('up-keep', '');
    }
});
